import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { startCase } from 'lodash';
import { useLocale } from 'pe-core-frontend';
import { AiFeedbackButtons } from './AiFeedbackButtons';
import styles from './AiSummary.module.scss';
import { ErrorDisplay, formatValue } from './utils';
const getDisplayableFields = (document) => {
    if (!document || typeof document !== 'object')
        return [];
    const entries = Object.entries(document)
        .filter(([key, value]) => key !== 'document_name' &&
        key !== 'documentName' &&
        key !== 'documentType' &&
        (key !== 'error' || value) // Include error only if it has a value
    )
        .map(([key, value]) => {
        if (key === 'response' && value && typeof value === 'object') {
            return Object.entries(value)
                .filter(([key]) => key !== 'document_name' &&
                key !== 'documentName' &&
                key !== 'document_type' &&
                key !== 'documentType')
                .map(([key, val]) => [key, val]);
        }
        return [[key, value]];
    })
        .flat()
        .filter(([_, value]) => value !== undefined && value !== null && value !== ''); // Filter out empty values
    return entries;
};
export const ExtractionDisplay = ({ llmRequestId, llmResponse, clientId, userId, aiSummaryId, }) => {
    const { t } = useLocale();
    const hasError = llmResponse.error;
    if (hasError) {
        return _jsx(ErrorDisplay, { requestId: llmRequestId, error: llmResponse.error || '' });
    }
    const fields = getDisplayableFields(llmResponse);
    return (_jsx("section", { className: styles.section, children: _jsxs("table", { className: styles.documentDisplayTable, children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: t('Field') }), _jsx("th", { children: t('Value') }), _jsx("th", { children: t('Feedback') })] }) }), _jsx("tbody", { children: fields.map(([field, value]) => {
                        const formattedField = startCase(field);
                        return (_jsx(_Fragment, { children: _jsxs("tr", { children: [_jsx("td", { children: _jsx("div", { children: t(formattedField) }) }), _jsx("td", { children: _jsx("div", { children: formatValue(value) }) }), _jsx("td", { children: _jsx(AiFeedbackButtons, { field: field, clientId: clientId, userId: userId, aiSummaryId: aiSummaryId }) })] }, field) }));
                    }) })] }) }));
};
